import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { ContainerModule } from './container/container.module';
import { ConverterService } from './core/converter.service';
import { AuthorizationService } from './core/authorization.service';
import { MyDateAdapter } from './shared/my-date-adapter.component';
import { AppRoutingModule } from './app-routing.module';
import { AppPreloadingStrategy } from './app-loading-strategy';

import { AuthenticationService } from './security/authentication.service';
import { NoPermissionsComponent } from './security/no-permissions/no-permissions.component';
import { EnvironmentServiceProvider } from './environment.service.provider';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AmbraAutoUpdaterService } from './version/ambra-auto-updater.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';

const MY_DATE_FORMATS = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@NgModule({
  declarations: [AppComponent, NoPermissionsComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    AppRoutingModule,
    ContainerModule,
    ReactiveFormsModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    AuthenticationService,
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthenticationService) => () => auth.refreshTokenOrRedirect(),
      deps: [AuthenticationService],
      multi: true,
    },
    AppPreloadingStrategy,
    HttpClientModule,
    ConverterService,
    EnvironmentServiceProvider,
    AuthorizationService,
    {
      provide: DateAdapter,
      useClass: MyDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_DATE_FORMATS,
    },
    AmbraAutoUpdaterService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
